var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var HotelDescriptionAndFeaturesModal = function () {
            function HotelDescriptionAndFeaturesModal() {
                _classCallCheck(this, HotelDescriptionAndFeaturesModal);

                this.bindEvents();
            }

            _createClass(HotelDescriptionAndFeaturesModal, [{
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;

                    document.addEventListener('click', function (event) {
                        var trigger = event.target.closest('[data-modal-content-id]');
                        if (!trigger) {
                            return;
                        }

                        if (trigger.dataset.modalKind === 'description') {
                            _this.openDescriptionModal(trigger);
                            return;
                        }

                        if (!trigger.classList.contains('hotel-feature')) {
                            return;
                        }

                        _this.openFeatureModal(trigger);
                    });
                }
            }, {
                key: "openFeatureModal",
                value: function openFeatureModal(trigger) {
                    var triggers = Array.from(trigger.closest('.hotel-features').querySelectorAll('.hotel-feature[data-modal-content-id]'));
                    var content = document.createElement('div');
                    content.className = 'hotel-feature-modal__sections';
                    var tabs = document.createElement('div');
                    tabs.className = 'hotel-feature-modal__tabs';
                    tabs.setAttribute('role', 'tablist');
                    var sections = triggers.map(function (item) {
                        var panel = document.getElementById(item.dataset.modalContentId);
                        var placeholder = document.createComment('hotel-feature-panel');
                        panel.before(placeholder);
                        var tab = document.createElement('button');
                        tab.type = 'button';
                        tab.className = 'hotel-feature-modal__tab';
                        tab.textContent = item.dataset.modalTitle;
                        tab.id = panel.id + 'Tab';
                        tab.setAttribute('role', 'tab');
                        tab.setAttribute('aria-controls', panel.id);
                        panel.setAttribute('role', 'tabpanel');
                        panel.setAttribute('aria-labelledby', tab.id);
                        tabs.appendChild(tab);
                        content.appendChild(panel);
                        return { panel: panel, placeholder: placeholder, tab: tab };
                    });
                    var modalElement = void 0;
                    var selectSection = function selectSection(selected) {
                        sections.forEach(function (section) {
                            var active = section === selected;
                            section.panel.hidden = !active;
                            section.tab.setAttribute('aria-selected', String(active));
                            section.tab.tabIndex = active ? 0 : -1;
                        });
                        if (modalElement) {
                            modalElement.querySelector('.modal2-content').scrollTop = 0;
                            modalElement.querySelector('.modal2-title').textContent = selected.tab.textContent;
                        }
                        var tabOffset = selected.tab.offsetLeft - tabs.offsetLeft - 16;
                        var maxScroll = tabs.scrollWidth - tabs.clientWidth;
                        tabs.scrollTo({ left: Math.max(0, Math.min(tabOffset, maxScroll)), behavior: 'smooth' });
                        selected.panel.querySelectorAll('.hotel-photo-gallery .swiper').forEach(function (element) {
                            if (element.swiper) {
                                element.swiper.update();
                                if (element.swiper.pagination) {
                                    element.swiper.pagination.render();
                                    element.swiper.pagination.update();
                                }
                            }
                        });
                    };
                    content.addEventListener('click', function (event) {
                        var image = event.target.closest('.hotel-photo-slide');
                        if (!image) return;
                        var gallery = image.closest('.hotel-photo-gallery');
                        var images = Array.from(gallery.querySelectorAll('.hotel-photo-slide'));
                        var photos = hotelPhotoGallery.getFullscreenPhotosFromElements(images, image.alt);
                        hotelPhotoGallery.openFullscreenGallery(photos, images.indexOf(image), 'open_fullscreen_photo');
                    });
                    sections.forEach(function (section, index) {
                        section.tab.addEventListener('click', function () {
                            return selectSection(section);
                        });
                        section.tab.addEventListener('keydown', function (event) {
                            var next = void 0;
                            if (event.key === 'ArrowRight') next = (index + 1) % sections.length;
                            if (event.key === 'ArrowLeft') next = (index + sections.length - 1) % sections.length;
                            if (event.key === 'Home') next = 0;
                            if (event.key === 'End') next = sections.length - 1;
                            if (next === undefined) return;
                            event.preventDefault();
                            selectSection(sections[next]);
                            sections[next].tab.focus();
                        });
                    });
                    window.modal.open({
                        header: {
                            title: triggers[0].dataset.modalTitle,
                            theme: window.modal.themes.PRIMARY
                        },
                        type: window.modal.types.FULL,
                        parentCssClass: 'hotel-feature-modal',
                        content: { html: content },
                        footer: false,
                        onAfterShow: function onAfterShow(modal) {
                            modalElement = modal;
                            modal.querySelector('.modal2-header').appendChild(tabs);
                            selectSection(sections.find(function (section) {
                                return section.panel.id === trigger.dataset.modalContentId;
                            }));
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            sections.forEach(function (_ref) {
                                var panel = _ref.panel,
                                    placeholder = _ref.placeholder;

                                panel.hidden = false;
                                panel.removeAttribute('role');
                                panel.removeAttribute('aria-labelledby');
                                placeholder.replaceWith(panel);
                            });
                        }
                    });
                }
            }, {
                key: "openDescriptionModal",
                value: function openDescriptionModal(trigger) {
                    this.openModal(trigger, {
                        header: {
                            title: trigger.dataset.modalTitle,
                            theme: window.modal.themes.PRIMARY
                        },
                        type: window.modal.types.FULL,
                        parentCssClass: 'hotel-description-modal'
                    });
                }
            }, {
                key: "openModal",
                value: function openModal(trigger, modalOptions) {
                    var contentId = trigger.dataset.modalContentId;
                    if (!contentId) {
                        return;
                    }

                    window.modal.open(Object.assign({
                        content: {
                            htmlDetachSelectorId: contentId
                        },
                        footer: false,
                        onAfterShow: function onAfterShow(modal) {
                            var content = modal.querySelector("#" + contentId);
                            if (content) {
                                content.classList.remove('hidden');
                            }

                            modal.querySelectorAll('.hotel-photo-gallery .swiper').forEach(function (swiperElement) {
                                if (!swiperElement.swiper) {
                                    return;
                                }

                                swiperElement.swiper.update();
                                if (swiperElement.swiper.pagination) {
                                    swiperElement.swiper.pagination.render();
                                    swiperElement.swiper.pagination.update();
                                }
                            });
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            var content = document.getElementById(contentId);
                            if (content) {
                                content.classList.add('hidden');
                            }
                        }
                    }, modalOptions));
                }
            }]);

            return HotelDescriptionAndFeaturesModal;
        }();

        if (window.modal && typeof window.modal.open === 'function') {
            new HotelDescriptionAndFeaturesModal();
        }
    }, {}] }, {}, [1]);